// Apply keeps one row per security. A row that resolved to a security the
// change already keeps is listed among its excluded rows with this reason; it
// needs no action from the user.
const DUPLICATE_SECURITY_REASON = 'duplicate_security';

export function isDuplicateSecurityRow(row) {
    return row?.resolution_reason_code === DUPLICATE_SECURITY_REASON;
}

/** The reason shown for a duplicate row, naming the row Apply kept. */
export function duplicateSecurityReasonText(row) {
    const kept = row?.duplicate_of || {};
    const name = String(kept.ticker || kept.inbound_id_value || '').trim();
    if (kept.already_on_watchlist) {
        return name
            ? `Already on your Watchlist as ${name} — not added`
            : 'Already on your Watchlist — not added';
    }
    return `Same security as ${name || 'another row'} in this change — not added`;
}
